export enum enTerminalMethod {
  CREDIT = 'credit',
  DEBIT = 'debit',
  VOUCHER = 'voucher'
}
